// extracted by mini-css-extract-plugin
export var container = "CompetitionPage-module--container--GYnE-";
export var wrapper = "CompetitionPage-module--wrapper--6j4XH";
export var hero = "CompetitionPage-module--hero--3MddF";
export var title = "CompetitionPage-module--title--3lUCM";
export var subtitle = "CompetitionPage-module--subtitle--3a9C2";
export var image = "CompetitionPage-module--image--1o1nS";
export var form = "CompetitionPage-module--form--1aQFW";